"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var EditCompany_1 = require("../../../components/Pages/Company/EditCompany");
var withRouter_1 = require("../../hooks/withRouter");
var SingleCustomer = function (props) {
    return React.createElement(EditCompany_1.default, { id: props.router.params.id });
};
exports.default = (0, withRouter_1.default)(SingleCustomer);
